<template>
  <va-navbar class="app-navbar">
    <a href="/">
      <img class="annuaire-logo" :src="logoimg.img" href="/" />
    </a>
    <header-selector slot="selector" :minimized.sync="minimizedProxy" />
    <template slot="center"></template>
    <div class="app-navbar__actions row flex-nowrap align--center">
      <notification-dropdown class="va-navbar__item" />
      <profile-dropdown class="va-navbar__item">
        <span>{{ username }}</span>
      </profile-dropdown>
    </div>
  </va-navbar>
</template>

<script>
import HeaderSelector from "./components/HeaderSelector";
import ProfileDropdown from "./components/dropdowns/ProfileDropdown";
import NotificationDropdown from "./components/dropdowns/NotificationDropdown";

export default {
  name: "app-navbar",
  components: {
    HeaderSelector,
    NotificationDropdown,
    ProfileDropdown
  },
  props: {
    minimized: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      logoimg: {
        title: "Logo OPEF",
        img: require("@/assets/opef_med_bleu.png")
      }
    };
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
    username: function() {
      let disp = "";
      if (this.$store.getters.user.nom) {
        disp = disp + this.$store.getters.user.nom;
      }
      if (this.$store.getters.user.prenom) {
        disp = disp + " " + this.$store.getters.user.prenom;
      }
      return disp;
    },

    minimizedProxy: {
      get() {
        return this.minimized;
      },
      set(minimized) {
        this.$emit("update:minimized", minimized);
      }
    }
  }
};
</script>
<style lang="scss">
.app-title {
  font-size: 1.1rem;
  padding: 0;
  margin: 0;
  font-weight: bold;
  text-shadow: 10px;
}
.app-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.app-navbar {
  &__button {
    width: 10.8125rem;
    .va-button__content__icon-left.fa-github {
      font-size: 1.5rem;
    }
  }
  &__actions {
    justify-content: flex-end;
  }
  &__mailto-link:hover {
    filter: brightness(85%);
  }
  @include media-breakpoint-down(lg) {
    &__button {
      display: none !important;
    }
    .profile-dropdown {
      margin: auto 0 auto 0.75rem;
    }
  }
  @include media-breakpoint-down(md) {
    @at-root .va-navbar__text {
      display: none !important;
    }
  }
  @include media-breakpoint-down(sm) {
    &__button {
      display: none !important;
    }
    &__actions {
      justify-content: space-around;
      padding: 0 0.5rem;
    }
    .profile-dropdown {
      position: absolute;
      right: 0.75rem;
      top: 1.25rem;
      height: fit-content;
      margin: auto;
    }
  }
}

.annuaire-logo {
  position: absolute;
  left: 3.25rem;
  top: 0.25rem;
  width: 5rem;
  height: 5rem;
}
</style>
